<template>
  <div>
    <ib-charts-placeholder v-if="isDirectCostsEmpty" />
    <el-tabs
      v-else
      v-model="activeTab"
      class="mb-3 tabs"
    >
      <!-- Timeline -->
      <el-tab-pane
        :label="$t('timeline')"
        name="first"
        lazy
      >
        <div class="bg-white">
          <direct-costs-over-time
            v-if="activeTab === 'first'"
            class="pt-4 pb-1"
            chart-animations
          />
        </div>
      </el-tab-pane>
      <!-- /Timeline -->

      <!-- Breakdown -->
      <el-tab-pane
        :label="$t('breakdown')"
        name="second"
        lazy
      >
        <div class="bg-white">
          <distribution-of-direct-costs
            v-if="activeTab === 'second'"
            class="pt-4 pb-1"
            chart-animations
          />
        </div>
      </el-tab-pane>
      <!-- /Breakdown -->

      <!-- Table -->
      <el-tab-pane
        :label="$t('table')"
        name="third"
        lazy
      >
        <div class="bg-white pt-4 pb-2">
          <direct-costs-table />
        </div>
      </el-tab-pane>
      <!-- /Table -->
    </el-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import DirectCostsOverTime from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/DirectCost/DirectCostsOverTime.vue'
import DirectCostsTable from '@/views/Home/StoryMode/Forecast/DirectCosts/Tables/DirectCostsTable.vue'
import DistributionOfDirectCosts from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/DirectCost/DistributionOfDirectCosts.vue'

export default {
  name: 'DirectCostsTabs',

  components: { DirectCostsTable, DistributionOfDirectCosts, DirectCostsOverTime },

  data () {
    return {
      activeTab: 'first'
    }
  },

  computed: {
    ...mapState(['idea']),

    isDirectCostsEmpty () {
      return this.idea.storyMode.forecast.directCosts.directCosts.length === 0
    }
  }
}
</script>

<style scoped lang="scss">
.tabs {
  ::v-deep {
    .el-tabs__content {
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 0 0 8px 8px;
    }
  }
}
</style>
